import useCardPlate from '../../application/hooks/useCardPlate';

const Cardplate = () => {
  const { source, alt } = useCardPlate();

  return (
    <>
      {source && alt && (
        <img style={{ width: '100%' }} src={source} alt={alt} />
      )}
    </>
  );
};

export default Cardplate;
